"use client";
const c = (n) => {
  const t = /<em>(.*?)<\/em>/gs;
  let e;
  const s = [];
  let h = 0;
  for (; (e = t.exec(n)) !== null; ) {
    const [i, l] = e;
    e.index > h && s.push(n.slice(h, e.index)), s.push({ content: l, highlighted: !0 }), h = e.index + i.length;
  }
  return h < n.length && s.push(n.slice(h)), s;
};
export {
  c as highlightEmphasis
};
